$(document).ready(function () {  
  // Tab switching
  $(".tab-button").on("click", function () {
    if(!$(this).hasClass('active')){
      $(".tab-button").removeClass("active");
      $(this).addClass("active");
      $(".basket-container").hide();
      var bundleType = $(this).data("bundle-type");
      var bundle_count = $(this).data('bundle-count')
      $(".basket-container").removeClass('active')
      $(".basket-container[data-bundle-type='" + bundleType + "']").show();
      $(".basket-container[data-bundle-type='" + bundleType + "']").addClass('active');
      $('.cart-counter').text(`Add ${bundle_count} More`);
  
      // Clear basketItems when tab changes
      // basketItems = [];
      var bundleType = $(".tab-button.active").data("bundle-type");
      var $basketItems = $(`.${bundleType}-bundle.basket-items`);
      $basketItems.empty();
      updateBasket();
      resetBasket();
    }    
  });

  // Bundle Items Slider
  // $('.six-bundle.basket-items')

  var basketItems = [];
  var salePriceArray = [];
  var originalPriceArray = [];
  $(".quantity-container").hide();
  $(".add-button").on("click", function () {
    var $producerContainer = $(this).closest(".producer");
    var indexId = $producerContainer.data("index-id");
    var prodId = $producerContainer.data("prod-id");
    var prodTitle = $producerContainer.data("title");
    var productImage = $producerContainer.find("img").attr("src");
    var $quantityContainer = $producerContainer.find(".quantity-container");
    var salePrice = $producerContainer.data("sale-price");
    var originalPrice = $producerContainer.data("original-price");
    var quantityInput = $quantityContainer.find(".quantity-input");
    var bundleCount = $(".tab-button.active").data("bundle-count");
    var bundleType = $(".tab-button.active").data("bundle-type");
    var bundleImgUrl = $(`.basket-container[data-bundle-type="${bundleType}"]`).data("img-url");
    var quantity = parseInt(quantityInput.val());

    if (!$quantityContainer.is(":visible")) {
      $quantityContainer.show();
    }

    addToBasket(
      indexId,
      productImage,
      quantity,
      prodId,
      prodTitle,
      bundleImgUrl,
      salePrice,
      originalPrice
    );
    updateVisibility($producerContainer);
  });

  $(".plus-button").on("click", function () {
    var $producerContainer = $(this).closest(".producer");
    var $quantityInput = $(this).siblings(".quantity-input");
    var currentQuantity = parseInt($quantityInput.val());
    $quantityInput.val(currentQuantity + 1);
    updateBasketQuantity($producerContainer, 1);
  });

  $(".minus-button").on("click", function () {
    var $producerContainer = $(this).closest(".producer");
    var $quantityInput = $(this).siblings(".quantity-input");
    var $quantityContainer = $producerContainer.find(".quantity-container");
    var currentQuantity = parseInt($quantityInput.val());

    if (currentQuantity > 1) {
      $quantityInput.val(currentQuantity - 1);
      updateBasketQuantity($producerContainer, -1);
    } else {
      $quantityContainer.hide();
      $producerContainer.find(".add-button").show();
      removeFromBasket($producerContainer.data("index-id"));
    }
  });

  $(document).on("click", ".remove-button", function () {
    var $itemInfo = $(this).closest(".item-info");
    var indexId = $itemInfo.data("index-id");
    var $quantityInput = $itemInfo.find(".item-quantity");
    var currentQuantity = parseInt($quantityInput.data("quant"));
    var updatedQuant = currentQuantity - 1;

    var $producerContainer = $('.producer[data-index-id="' + indexId + '"]');
    $producerContainer.find(".quantity-container .minus-button").click();
  });

  $(document).on("click", ".cart-btn", async function (e) {
    e.preventDefault();
    var bundleTypeAttr = $(".tab-button.active").data("bundle-type");
    var cartItemLimit = $(".tab-button.active").data("bundle-count");
    var bundleType = "bundle-group-" + theme.current_page + ":" + Date.now();
    var bundle_title = "Case Size - " + bundleTypeAttr;

    let totalQuantity = 0;
    const limitedBasketItems = [];

    for (const item of basketItems) {
        if (totalQuantity >= cartItemLimit) break;

        const remainingQuantity = cartItemLimit - totalQuantity;
        const itemQuantity = item.quantity;

        if (itemQuantity <= remainingQuantity) {
            limitedBasketItems.push(item);
            totalQuantity += itemQuantity;
        } else {
            limitedBasketItems.push({
                ...item,
                quantity: remainingQuantity
            });
            totalQuantity += remainingQuantity;
        }
    }

    const cartArray = limitedBasketItems.map((item) => ({
      quantity: item.quantity,
      id: item.prodId,
      properties: {
        _bundle_type: bundleType,
        _bundle_title: bundle_title,
        _product_title: item.prodTitle,
        _bundle_img: item.bundleImgUrl,
      },
    }));

    // console.log(cartArray,limitedBasketItems);
    let formData = {
      items: cartArray,
    };

    var t = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      dataType: "json",
      body: JSON.stringify(formData),
    };

    var result = await theme.cart.addItem(t, null);
    console.log("result",result.ok)
    if(result.ok){
      setTimeout(() => {
        let cartBtn = $('.cart-item button.cart-btn');
        cartBtn.prop('disabled', false).parent().remove('.cart-error')
        theme.drawer.open("right", "cart-drawer", this);
        if(theme.offer_progress_bar){  
          offer_progressbar();
        }
        basketItems = [];
        updateBasket();
        resetBasket();
        $('button:not(.cart-btn),input').removeAttr('disabled').show();
      }, 200);      
    }else{
      var message = result.message
      var errorHTML = `<p class="cart-error" style="margin: 10px 0;">${message}</p>`
      let cartBtn = $('.cart-item button.cart-btn')
      cartBtn.prop('disabled', true).parent().prepend(errorHTML)
    }

  });

  // Add Product/Items in basket
  function addToBasket(
    indexId,
    productImage,
    quantity,
    prodId,
    prodTitle,
    bundleImgUrl,
    salePrice,
    originalPrice
  ) {
    var existingItem = basketItems.find(function (item) {
      return item.indexId === indexId;
    });
    if (!existingItem) {
      basketItems.push({
        indexId: indexId,
        productImage: productImage,
        quantity: quantity,
        prodId: prodId,
        prodTitle: prodTitle,
        bundleImgUrl: bundleImgUrl,
        salePrice: salePrice,
        originalPrice: originalPrice,
      });
    } else {
      existingItem.quantity = quantity;
    }
    updateBasket();
  }

  // function updateBasket() {
  //   var saletotal = 0;
  //   var originaltotal = 0;
  //   var bundleCount = $(".tab-button.active").data("bundle-count");
  //   var bundleType = $(".tab-button.active").data("bundle-type");
  //   var $basketItems = $(`.${bundleType}-bundle.basket-items`);
  //   $basketItems.empty();

  //   salePriceArray = [];
  //   originalPriceArray = [];

  //     const totalQuantity = basketItems.reduce((sum, item) => sum + item.quantity, 0);
  //     var itemsToAdd = Math.min(bundleCount, totalQuantity);
      
  //     var addedItems = 0; // Track the number of added items
      
  //     for (var i = 0; i < basketItems.length; i++) {
  //         var item = basketItems[i];
  //         for (var j = 0; j < item.quantity && addedItems < itemsToAdd; j++) {
  //             var html = `
  //                 <div class="item-info" data-index-id="${item.indexId}">
  //                   <img src="${item.productImage}">
  //                   <input type="hidden" class="item-quantity" data-sale-price="${item.salePrice}" data-original-price="${item.originalPrice}" data-quant="${item.quantity}" data-title="${item.prodTitle}" data-prod-id="${item.prodId}">
  //                   <button class="remove-button">X</button>
  //                   <h6 class="item-title">${item.prodTitle}</h6>
  //                 </div>`;
  //             $basketItems.append(html);
      
  //             var is_saletotal = parseFloat(item.salePrice) || 0;
  //             var is_originaltotal = parseFloat(item.originalPrice) || 0;
      
  //             salePriceArray.push(is_saletotal);
      
  //             // Use salePrice if originalPrice is not available or <= 0
  //             originalPriceArray.push(
  //               is_originaltotal == 0 ? is_saletotal : is_originaltotal
  //             );
      
  //             addedItems++; // Increment the count of added items
  //         }
      
  //         // If we've added enough items, break out of the loop
  //         if (addedItems >= itemsToAdd) {
  //             break;
  //         }
  //     }



  //   var salePrice = 0,
  //     originalPrice = 0;
  //   salePriceArray.forEach((el) => (salePrice += el));
  //   originalPriceArray.forEach((el) => (originalPrice += el));

  //   var discountOriginal =  originalPrice - (originalPrice * theme.bundle_discount_perc / 100);
  //   var savedPrice = parseInt(originalPrice) - parseInt(discountOriginal)

  //   var formattedSaleTotal = theme.utils.formatMoney(salePrice);
  //   var formattedOriginalTotal = theme.utils.formatMoney(originalPrice);
  //   var formattedDiscount = theme.utils.formatMoney(discountOriginal);
  //   var formattedsavedPrice = theme.utils.formatMoney(savedPrice);
    
  //   $(".item-sale__price").text(formattedDiscount);
  //   $(".save__price").text(formattedsavedPrice)
  //   $(".item-original__price").text(formattedSaleTotal);
    
  //   var itemCount = $($basketItems).find(".item-info").length;    
  //   var nullItemCount = Math.max(0, bundleCount - itemCount);
    
  //   if(parseInt(nullItemCount) > 0){
  //    $('.cart-counter').text(`Add ${nullItemCount} More`);
  //   }else{
  //     $('.cart-counter').text("Add To Cart");
  //   }
  //   for (var i = 0; i < nullItemCount; i++) {
  //     $basketItems.append('<div class="null-item"><img src="https://cdn.shopify.com/s/files/1/0816/2535/0436/files/null-item.png?v=1705644474"></div>');
  //   }

  //   // Add logic to toggle "sticky" class based on item count
  //   var $rightPanel = $(".right-panel");
  //   if (itemCount > 0) {      
  //     if($(window).width() < 767){
  //       var rightPanel = $(".right-panel"),
  //       rightPanelHeight = rightPanel.height() + 500,
  //       Mainelement = $(".bundle-page-height"),
  //       elementHeight = Mainelement.height(),
  //       offset = Mainelement.offset().top;
  
  //       var initialOffset = elementHeight + offset - rightPanelHeight;
  //       if ($(window).scrollTop() < initialOffset) {
  //         $rightPanel.addClass("sticky");
  //       }
  //     }else{
  //       $rightPanel.addClass("sticky");
  //     }
  //   } else {
  //     $rightPanel.removeClass("sticky");
  //   }
    
  //   if (nullItemCount == 0) {
  //     disabledElement();
  //   } else {
  //     enabledElement();
  //   }
  //   cartBtn();
  //   if(itemCount == 0){
  //     $('.cart-btn .ele').removeClass('show').addClass('hide');
  //   }else{
  //     $('.cart-btn .ele').removeClass('hide').addClass('show');
  //   }
  // }

  function updateBasket() {
    var saletotal = 0;
    var originaltotal = 0;
    var bundleCount = $(".tab-button.active").data("bundle-count");
    var bundleType = $(".tab-button.active").data("bundle-type");
    var $basketItems = $(`.${bundleType}-bundle.basket-items`);
    $basketItems.empty();

    salePriceArray = [];
    originalPriceArray = [];

    const totalQuantity = basketItems.reduce((sum, item) => sum + item.quantity, 0);
    var itemsToAdd = Math.min(bundleCount, totalQuantity);

    var addedItems = 0; // Track the number of added items

    for (var i = 0; i < basketItems.length; i++) {
        var item = basketItems[i];
        for (var j = 0; j < item.quantity && addedItems < itemsToAdd; j++) {
            var html = `
                <div class="item-info" data-index-id="${item.indexId}">
                    <img src="${item.productImage}">
                    <input type="hidden" class="item-quantity" data-sale-price="${item.salePrice}" data-original-price="${item.originalPrice}" data-quant="${item.quantity}" data-title="${item.prodTitle}" data-prod-id="${item.prodId}">
                    <button class="remove-button">X</button>
                    <h6 class="item-title">${item.prodTitle}</h6>
                </div>`;
            $basketItems.append(html);

            var is_saletotal = parseFloat(item.salePrice) || 0;
            var is_originaltotal = parseFloat(item.originalPrice) || 0;

            salePriceArray.push(is_saletotal);

            originalPriceArray.push(
                is_originaltotal == 0 ? is_saletotal : is_originaltotal
            );

            addedItems++; // Increment the count of added items
        }

        // If we've added enough items, break out of the loop
        if (addedItems >= itemsToAdd) {
            break;
        }
    }

    var salePrice = 0, originalPrice = 0;
    salePriceArray.forEach((el) => (salePrice += el));
    originalPriceArray.forEach((el) => (originalPrice += el));

    var isSixBottleCase = bundleCount === 6;

    var discount_type = theme.select_discount_type;
    var discount_amount =  theme.bundle_discount_perc;
    
    var discountOriginal;
    if (discount_type === "Amount") {
        var discountOriginal = isSixBottleCase ? originalPrice - (discount_amount * 100) : originalPrice;
    }else if (discount_type === "Percentage") {
       var discountOriginal = isSixBottleCase ? originalPrice - (originalPrice * (discount_amount / 100)) : originalPrice;
    }

    // var discountOriginal = isSixBottleCase ? originalPrice - (originalPrice * 0.10) : originalPrice;
    var savedPrice = originalPrice - discountOriginal;

    var formattedSaleTotal = theme.utils.formatMoney(salePrice);
    var formattedOriginalTotal = theme.utils.formatMoney(originalPrice);
    var formattedDiscount = theme.utils.formatMoney(discountOriginal);
    var formattedSavedPrice = theme.utils.formatMoney(savedPrice);

    $(".item-sale__price").text(formattedDiscount);
    $(".save__price").text(formattedSavedPrice);
    $(".item-original__price").text(formattedSaleTotal);

    // Hide or show item-original__price based on bundle count
    if (bundleCount === 3) {
        $(".item-original__price").hide(); // Hide for 3 bottles
    } else {
        $(".item-original__price").show(); // Show for 6 bottles
    }

    var itemCount = $($basketItems).find(".item-info").length;    
    var nullItemCount = Math.max(0, bundleCount - itemCount);
    
    if(parseInt(nullItemCount) > 0){
        $('.cart-counter').text(`Add ${nullItemCount} More`);
    }else{
        $('.cart-counter').text("Add To Cart");
    }
    for (var i = 0; i < nullItemCount; i++) {
        $basketItems.append('<div class="null-item"><img src="https://cdn.shopify.com/s/files/1/0816/2535/0436/files/null-item.png?v=1705644474"></div>');
    }

    // Add logic to toggle "sticky" class based on item count
    var $rightPanel = $(".right-panel");
    if (itemCount > 0) {      
        if($(window).width() < 768){
            var rightPanel = $(".right-panel"),
                rightPanelHeight = rightPanel.height() + 200,
                Mainelement = $(".bundle-page-height"),
                elementHeight = Mainelement.height(),
                offset = Mainelement.offset().top;

            var initialOffset = elementHeight + offset - rightPanelHeight;
            if ($(window).scrollTop() < initialOffset) {
                $rightPanel.addClass("sticky");
            }
        } else {
            $rightPanel.addClass("sticky");
        }
    } else {
        $rightPanel.removeClass("sticky");
    }

    if (nullItemCount == 0) {
        disabledElement();
    } else {
        enabledElement();
    }
    
    cartBtn();
    
    if(itemCount == 0){
        $('.cart-btn .ele').removeClass('show').addClass('hide');
    }else{
        $('.cart-btn .ele').removeClass('hide').addClass('show');
    }
}


  // Disable add item button when basket is full
  function disabledElement() {
    let activeElement = $(".producer").find(".add-product input:visible, .add-product button:visible:not(.info-button)");
    activeElement.each(function () {
      if($(this).hasClass('sold-out')){
        $(this).prop("disabled", true);  
      }
      $(this).prop("disabled", true);
    });
  }

  // Disable add item button when basket is empty
  function enabledElement() {
    let activeElement = $(".producer").find(".add-product input:visible, .add-product button:visible:not(.info-button)");
    activeElement.each(function () {
      if($(this).hasClass('sold-out')){
        $(this).attr("disabled", 'disabled');
        $(this).prop("disabled", true);
      }else{
        $(this).prop("disabled", false);
      }
    });
  }

  // "Add to basket" button hide when one item added in basket
  function updateVisibility($producerContainer) {
    $producerContainer.find(".add-button").hide();
    cartBtn();
  }

  // Update Quantity when add item increase/decrease in a basket
  function updateBasketQuantity($producerContainer, increment) {
    var indexId = $producerContainer.data("index-id");

    var existingItem = basketItems.find(function (item) {
      return item.indexId === indexId;
    });

    if (existingItem) {
      existingItem.quantity += increment;

      if (existingItem.quantity === 0) {
        $producerContainer.find(".quantity-container").hide();
        $producerContainer.find(".add-button").show();
        removeFromBasket(indexId);
      }
      updateBasket();
    }
    cartBtn();
  }

  // Remove Items from basket
  function removeFromBasket(indexId) {
    basketItems = basketItems.filter(function (item) {
      return item.indexId !== indexId;
    });
    updateBasket();
  }

  // Cart Button Enable/Disable
  function cartBtn() {
    var bundleType = $(".tab-button.active").attr("data-bundle-type");
    if ($(`.${bundleType}-bundle.basket-items .null-item`).length > 0) {
      $(".cart-btn").prop("disabled", true);
    } else {
      $(".cart-btn").prop("disabled", false);
    }
  }
  cartBtn();

  // Reset Basket when change bundle Type
  function resetBasket() {
    var producerElement = $(".producer .quantity-container:visible");
    var $addButton = $(".producer .add-button:hidden");
    if (basketItems.length == 0) {
      producerElement.each(function () {
        $(this).hide();
        $(this).find("input").val("1");
      });
      if ($($addButton).prop("disabled")) {
        if(!$($addButton).hasClass('sold-out')){
          $($addButton).prop("disabled", false).show();          
        }
      } else {
        $($addButton).show();
      }
    }
  }

  // ******* Sticky Basket JQ *******
  var windoSize = $(window).width();
  if (windoSize <= 767) {
    var rightPanel = $(".right-panel"),
      rightPanelHeight = rightPanel.height() + 500,
      Mainelement = $(".bundle-page-height"),
      elementHeight = Mainelement.height(),
      offset = Mainelement.offset().top;

    var initialOffset = elementHeight + offset - rightPanelHeight;
    var $rightPanel = $(".right-panel");
    
    $(window).scroll(function () {
      var count = $(".right-panel .basket-container.active .item-info").length;
      if(count > 0){
        if ($(window).scrollTop() < initialOffset) {
          rightPanel.addClass("sticky");
        } else {
          rightPanel.removeClass("sticky");
        }
      }
    });
  }

  // Add Animation on the Bundle Page
  var animationButton = document.querySelectorAll('.product--quick-add--form .buttonAnimation');
  animationButton.forEach(function(animationButton, index) {
      var fillBtn = document.createElement('div');
      fillBtn.className = 'fill-btn';

      var borderBtn = document.createElement('div');
      borderBtn.className = 'border-btn';

      animationButton.appendChild(fillBtn);
      animationButton.appendChild(borderBtn);
  });
  $('.buttonAnimation').mouseenter(function(e){        
    var $this = $(this),
        top = $this.offset().top,
        left = $this.offset().left,
        pageX = e.pageX,
        pageY = e.pageY;
    $(this).find('.fill-btn').css({
      "top": pageY-top,
      "left": pageX-left,
    });
  });

  // ******* Remove Bundle Item From Cart *******

  $("body").on("click", ".remove-items a", function (e) {
    e.preventDefault();
    var ids = $(this).attr("data-ids");
    var line_num = $(this).parents('.cart--item').attr('data-line-num')
    removeItems(ids);
  });

  function removeItems(items) {
    // console.log(items);
    // var itemsProcessed = items;
    // // console.log(itemsProcessed);
    // var itemsArray = itemsProcessed.split(",");
    // var qty = 0;
    // var data = { updates: {} };

    // for (i = 0; i < itemsArray.length; i++) {
    //   data.updates[itemsArray[i]] = qty;
    // }
    // $.ajax({
    //   type: "POST",
    //   url: "/cart/update.js",
    //   data: data,
    //   dataType: "json",
    //   success: function (res) {
    //     // console.log(res);
    //     if (res) {
    //       theme.cart.updateAllHtml(true);
    //       theme.cart.fetchTotals();
    //     }
    //     // window.location.reload();
    //   },
    // });
  }

  var url_id = window.location.hash.split('#')[1];
  // console.log(url_id)
  if(url_id){
    if(url_id.includes("six") || url_id.includes("three")){
      // console.log(url_id,$(".tab-button[data-bundle-type='"+url_id+"']"))
      $(".tab-button[data-bundle-type='"+url_id+"']").click();
    }
  }

  function free_shipping(note_val) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;",
      },
      body: JSON.stringify({
        attributes: {
          _free_shipping: note_val,
        },
      }),
    });
  }
  function offer_progressbar() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        var cart_total = cart.total_price;
        var result = (cart_total / discount_thresold_1) * 100;
        if (cart_total <= discount_thresold_1 && discount_thresold_1 != "") {
          var away = discount_thresold_1 - cart_total;
          var msg1 = first_before_msg.replaceAll("XX",theme.utils.formatMoney(away));
          $(".offer-progressbar_txtop").empty().html(msg1);
          if (result > 100) {
            $(".offer-progressbar-inner").css("width", "100%");
          } else {
            $(".offer-progressbar-inner").css("width", result + "%");
          }
          free_shipping("");
        } else {
          free_shipping("yes");
          var msg1 = unlock_freeshipping_msj;
          $(".offer-progressbar_txtop").empty().html(msg1);
          $(".offer-progressbar-inner").css("width", "100%");
        }
      });
  }
    // console.log("bundle",theme.offer_progress_bar)
  if(theme.offer_progress_bar){  
    offer_progressbar()
  }
  $('.info-button').on('click',function(){
    var modal = document.getElementById("productInfoModal");
    var appendhtml = $('.modal-product-details');
    appendhtml.html('');
    var productId = this.getAttribute("data-productid");
    var productTitle = this.closest(".product-detail").getAttribute("data-title");
    var productImage = this.closest(".product-detail").querySelector("img").src;
    var productMiddlePart = this.closest(".product-detail").querySelector(".grid-product-data .middle-part").innerHTML;
    var productBottomPart = this.closest(".product-detail").querySelector(".grid-product-data .bottom-part").innerHTML;
    var productSalePrice = this.closest(".product-detail").getAttribute("data-sale-price");
    var soldOut = this.closest(".product-detail").querySelector('.add-product .add-button').getAttribute('data-sold-out')
    var formattedPrice = `£${(productSalePrice / 100).toFixed(2)}`;
    var productvariantid = this.closest(".product-detail").querySelector(".add-button").getAttribute("data-prodId");
    
    var modalContent = `
      <div class="product-info-details"> 
        <div class="top-bar-wrapper">
          <div class="top-bar-left">
            <h2>${productTitle}</h2>
            <p>PRICE: ${formattedPrice}</p>
          </div>
          <div class="add-product">
            <button class="add-button button buttonAnimation info-atc ${soldOut? `sold-out`: ``}" data-varid="${productvariantid}" ${soldOut? `disabled`: ``}>
              <span>${soldOut? `Sold Out` : `Add`}</span>
            </button>
          </div>
        </div>
        <div class="product-middle-wrapper">
          <div class="product-info-img">
            <img src="${productImage}" alt="${productTitle}">
          </div>
          <div class="right-part">
            ${productMiddlePart}        
          </div>          
        </div>
        <div class="bottom-wrapper">
          ${productBottomPart}
        </div>        
      </div>`;
      appendhtml.append(modalContent);
      modal.style.display = "block";

      setTimeout(function() {
      var animationButton = document.querySelector('.add-product .info-atc');
      if (animationButton) {
        var fillBtn = document.createElement('div');
        fillBtn.className = 'fill-btn';

        var borderBtn = document.createElement('div');
        borderBtn.className = 'border-btn';

        animationButton.appendChild(fillBtn);
        animationButton.appendChild(borderBtn);

        $(animationButton).mouseenter(function(e) {
          var $this = $(this),
            top = $this.offset().top,
            left = $this.offset().left,
            pageX = e.pageX,
            pageY = e.pageY;
          $this.find('.fill-btn').css({
            "top": pageY - top,
            "left": pageX - left,
          });
        });
      }
    }, 500); 
    
    
    var closeButton = $(".close-button")[0];
    closeButton.onclick = function() {
      modal.style.display = "none";
    }
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }

    var hideTimeout;
    $(window).on('scroll', function() {
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(function() {
        modal.style.display = "none";
        $(window).off('scroll');
      }, 300);
    });
  });

  $(document).on('click','.add-button', function(){
    if(!$(this).hasClass('sold-out')){
      var varId = $(this).attr('data-varid')
      var atcBtn = $('.add-button[data-prodId="'+varId+'"]');
      if(!$(atcBtn).is(':hidden')){
        $(atcBtn).trigger('click');      
      }else{
        if(!$(atcBtn).parent().find('.plus-button').is(":disabled")){
          $(this).prop('disabled', false);
          $(atcBtn).parent().find('.plus-button').trigger('click');
        }else{
          $(this).prop('disabled', true);
        }
      }
    }else{
      $(this).prop('disabled', true);
    }
  });

});